import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lowversion = _resolveComponent("Lowversion")!

  return (_ctx.highversion)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([_ctx.xpTheme, "versiontip"])
      }, [
        _createVNode(_component_Lowversion, { na: _ctx.na }, null, 8, ["na"])
      ], 2))
}